module.exports = __webpack_public_path__ + "img/header-4.8bf1ee9d.png";